import * as XLSX from 'xlsx'
import XLSXS from 'xlsx-style'
import FileSaver from 'file-saver'

// name 文件名 data 数据 wch列宽度（接收数组）
function outExcel(name, data, wch) {
  console.log("🚀 ~ outExcel ~ XLSX:", XLSX)
  // 导出的excel文件名
  const filename = `${name}_${new Date().Format('yyyy年MM月dd日')}.xlsx`
  // Excel第一个sheet的名称
  const ws_name = 'Sheet1'
  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.json_to_sheet(data)
  XLSX.utils.book_append_sheet(wb, ws, ws_name) // 将数据添加到工作薄

  // 设置标题行单元格合并
  // s即start, e即end, r即row, c即column
  // 合并从--0行0列开始,到0行3列
  // ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 3 } }];

  // 设置单元格宽度
  ws['!cols'] = []
  wch.forEach(val => {
    ws['!cols'].push({ wch: +val })
  })

  /*
  设置单元格其他样式
  这里列举一部分,其他样式大同小异,自行网上搜索
 */

  // 可以遍历全部单元格,进行样式设置
  for (const i in ws) {
    if (/[A-Z]1$/.test(i)) {
      ws[i].s = {
        // 居中
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true
        },
        fill: {
          // fgColor: { rgb: '4489ce' }  
          fgColor: { rgb: 'C0C0C0' }  // 表头背景颜色
          
        },
        font: {
          color: {
            rgb: '000000'   //  表头字体颜色
          }
        },
        border: {
          top: {
            style: 'thin'
          },
          bottom: {
            style: 'thin'
          },
          left: {
            style: 'thin'
          },
          right: {
            style: 'thin'
          }
        }
      }
    }
  }

  // 导出Excel, 注意这里用到的是XLSXS对象
  const wbout = XLSXS.write(wb, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  })
  FileSaver.saveAs(
    new Blob([s2ab(wbout)], {
      type: 'application/octet-stream'
    }),
    filename
  )
}
/**
 * 工具方法
 */
function s2ab(s) {
  var buf = new ArrayBuffer(s.length)
  var view = new Uint8Array(buf)
  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
  return buf
}

// 导出
export {
  outExcel
}

